import { Url } from "./url";
import { environment } from "../../../../../environments/environment";

export class MdmBackendUrl extends Url {
  constructor(private action: string) {
    super(action);
  }

  public getUrl(): string {
    return environment.mdmBackendUrl + this.action;
  }
}

export class MdmProductsBackendUrl extends Url {
  constructor(private action: string) {
    super(action);
  }

  public getUrl(): string {
    return environment.mdmProductsBackendUrl + this.action;
  }
}
